import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../services/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribeSnapshot = null;

    const unsubscribeAuth = onAuthStateChanged(
      auth,
      (user) => {
        setCurrentUser(user);
        if (user) {
          // Escuchar cambios en el perfil de Firestore en tiempo real
          const userDocRef = doc(db, 'usuarios', user.uid);
          unsubscribeSnapshot = onSnapshot(
            userDocRef,
            (snapshot) => {
              if (snapshot.exists()) {
                setUserProfile({ id: snapshot.id, ...snapshot.data() });
              } else {
                setUserProfile(null);
              }
              setLoading(false);
            },
            (err) => {
              console.error('Error al obtener perfil de usuario:', err);
              setUserProfile(null);
              setLoading(false);
            }
          );
        } else {
          if (unsubscribeSnapshot) {
            unsubscribeSnapshot();
            unsubscribeSnapshot = null;
          }
          setUserProfile(null);
          setLoading(false);
        }
      },
      (error) => {
        console.error('Error en onAuthStateChanged:', error);
        setCurrentUser(null);
        setUserProfile(null);
        setLoading(false);
      }
    );

    // Timeout de seguridad por si onAuthStateChanged o Firestore no responden
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 4000);

    return () => {
      unsubscribeAuth();
      if (unsubscribeSnapshot) {
        unsubscribeSnapshot();
      }
      clearTimeout(timeout);
    };
  }, []);

  const isDemo = currentUser?.email?.toLowerCase() === 'demo@comarsa.com';
  const isAdmin = userProfile?.rol === 'admin' || isDemo;
  const isSupervisor = userProfile?.rol === 'supervisor' || isAdmin;

  const value = {
    currentUser,
    userProfile,
    isAdmin,
    isSupervisor,
    isDemo,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};